import { Component } from '@angular/core';

/**
 * Generated class for the CenterSpinnerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'center-spinner',
    templateUrl: 'center-spinner.html',
})
export class CenterSpinnerComponent {

    text: string;

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/components/center-spinner/center-spinner.ts